import { render, staticRenderFns } from "./LoanProductDetails.vue?vue&type=template&id=07bded8e&scoped=true&"
import script from "./LoanProductDetails.vue?vue&type=script&lang=js&"
export * from "./LoanProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./LoanProductDetails.vue?vue&type=style&index=0&id=07bded8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bded8e",
  null
  
)

export default component.exports